import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useApiControl from './common/useApiControl';

import BaseHeader from './components/headers/BaseHeader';
import RoomHeader from './components/headers/RoomHeader';
import NotLoginHeader from './components/headers/NotLoginHeader';
import SearchForm from './components/forms/SearchForm';
import TopList from './components/eventList/TopList';

const parseSearchParams = (search) => {
  const params = new URLSearchParams(search);
  const eventName = params.get('eventName')?.trim() ?? '';
  const ownerName = params.get('ownerName')?.trim() ?? '';
  const tagValue = params.get('tag') ?? '';
  const keyword = params.get('keyword')?.trim() ?? '';
  const tagId = tagValue !== '' ? Number(tagValue) : null;

  const apiParams = {};
  if (eventName) {
    apiParams.eventName = eventName;
  }
  if (ownerName) {
    apiParams.ownerName = ownerName;
  }
  if (tagId !== null && !Number.isNaN(tagId)) {
    apiParams.tag = tagId;
  }
  if (keyword) {
    apiParams.keyword = keyword;
  }

  return {
    apiParams,
    formValues: {
      eventName,
      ownerName,
      tag: tagValue,
      keyword,
    },
  };
};

function Search() {
  const location = useLocation();
  const [events, setEvents] = useState();
  const [masterTags, setMasterTags] = useState([]);

  const [isLogin, setIsLogin] = useState(null);
  const [user, setUser] = useState(null);

  const { apiParams, formValues } = useMemo(
    () => parseSearchParams(location.search),
    [location.search],
  );

  const { data: data1, loading: loading1, executeRequest: executeRequest1 } = useApiControl({
    action: '/is_login',
    params: '',
    method: 'POST',
  });

  useEffect(() => {
    executeRequest1().catch((error) => {
      console.error(error);
      setIsLogin(false);
    });
  }, []);

  useEffect(() => {
    if (data1) {
      setIsLogin(data1.is_login);
    }
  }, [data1]);

  const { data: data2, loading: loading2, executeRequest: executeRequest2 } = useApiControl({
    action: '/get_user',
    method: 'POST',
  });

  useEffect(() => {
    if (isLogin) {
      executeRequest2().catch((error) => {
        console.error(error);
      });
    }
  }, [isLogin]);

  useEffect(() => {
    if (data2) {
      setUser(data2);
    }
  }, [data2]);

  const { data: data3, loading: loading3, executeRequest: executeRequest3 } = useApiControl({
    action: '/get_events',
    params: apiParams,
    method: 'POST',
  });

  useEffect(() => {
    executeRequest3().catch((error) => {
      console.error(error);
    });
  }, [apiParams]);

  useEffect(() => {
    if (data3) {
      setEvents(data3.events);
    }
  }, [data3]);

  const { data: data7, loading: loading7, executeRequest: executeRequest7 } = useApiControl({
    action: '/get_master_tags',
    method: 'POST',
  });

  useEffect(() => {
    const localTags = localStorage.getItem('tags');
    if (localTags) {
      try {
        const parsedTags = JSON.parse(localTags);
        setMasterTags(parsedTags);
      } catch (e) {
        console.error('ローカルストレージのtagsパースエラー', e);
        executeRequest7();
      }
    } else {
      executeRequest7();
    }
  }, []);

  useEffect(() => {
    if (data7) {
      localStorage.setItem('tags', JSON.stringify(data7.tags));
      setMasterTags(data7.tags);
    }
  }, [data7]);


  const updateMasterTags = () => {
    localStorage.removeItem('tags');
    executeRequest7().catch((error) => {
      console.error(error);
    });
  };

  if (loading1 || loading2 || loading3 || loading7) {
    return (
      <>
        <BaseHeader />
        <SearchForm initialValues={formValues} tags={masterTags} />
        <TopList title={"検索結果"} />
      </>
    );
  }

  if (isLogin && user) {
    return (
      <>
        <RoomHeader user={user} />
        <SearchForm initialValues={formValues} tags={masterTags} />
        <TopList
          events={events}
          title={"検索結果"}
          masterTags={masterTags}
          user={user}
          updateMasterTags={() => updateMasterTags()}
        />
      </>
    );
  }

  return (
    <>
      <NotLoginHeader />
      <SearchForm initialValues={formValues} tags={masterTags} />
      <TopList
        events={events}
        title={"検索結果"}
        masterTags={masterTags}
        user={null}
        updateMasterTags={() => updateMasterTags()}
      />
    </>
  );
}

export default Search;
